import { feedServer } from "@/http";

export default {
    async createComment(state, payload) {
        const comment = {
            comment: payload.comment,
            name: localStorage.getItem('name') || 'Anonymous',
            avatar: localStorage.getItem('avatar') || ''
        }
        const response = await feedServer.post(`/comments/${payload.postId}`, JSON.stringify(comment), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (response.status !== 201) {
            throw new Error(response.message);
        }
        const commentPost = response.data;
        state.commit("cacheUserCommentPost", commentPost);
        const commentCountPost = {
            post_id: commentPost.post_id,
            comment_count: 1
        }
        state.commit("cacheCommentCountPost", commentCountPost);
    },
    async fetchAllCommentPost(state, payload) {
        const postIds = {
            post_ids: payload.postIds
        }
        const response = await feedServer.post('/comments/users', JSON.stringify(postIds), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (response.status !== 200) {
            throw new Error(response.message);
        }
        state.commit("setUserCommentPost", response.data);
    },
    async fetchAllCommentCountPost(state, payload) {
        const postIds = {
            post_ids: payload.postIds
        }
        const response = await feedServer.post('/comments/posts', JSON.stringify(postIds), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer' + localStorage.getItem('token')
            }
        });
        if (response.status !== 200) {
            throw new Error(response.message)
        }
        state.commit('setCommentCountPost', response.data)
    }
};